<template>
  <form action>
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head">
        <p class="modal-card-title is-size-5 is-capitalized">Book a free Trial</p>
      </header>
      <section class="modal-card-body">
        <b-field label="Name" :label-position="labelPosition">
          <b-input type="text" :value="email" placeholder="ex: Mannan Dattah" required></b-input>
        </b-field>

        <b-field label="Phone Number" :label-position="labelPosition">
          <b-input type="number" :value="contact" placeholder="9810 021 011" required></b-input>
        </b-field>
      </section>
      <footer class="modal-card-foot">
        <!-- <button class="button" type="button" @click="$parent.close()">Close</button> -->
        <button class="button is-primary is-capitalized is-fullwidth">Schedule my Trial</button>
      </footer>
    </div>
  </form>
</template>

<script>
export default {
  data() {
    return {
      labelPosition: "on-border"
    };
  }
};
</script>

<style lang="scss" scoped>
.modal-card {
  text-align: left;
  margin: 1em !important;
}

@media screen and (min-width: 768px) {
  .modal-card {
    min-width: 500px;
  }
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>